import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { CatalogInfoEditor } from './CatalogInfoEditor';

/** Entity-page tab: edit (or, for an auto-discovered stub with no
 *  catalog-info.yaml yet, author) the catalog-info.yaml for the entity in
 *  context and open a PR. This tab is the single entry point — onboarding a
 *  repo means opening it from that repo's catalog stub. */
export const CatalogInfoEditorTab = () => {
  const { entity } = useEntity();
  return <CatalogInfoEditor entity={entity} />;
};
